import React, { useEffect, useState } from 'react';

export interface IToast {
    title: string;
    message?: string;
    type: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
    toastId?: number;
}

export const ToastContext = React.createContext<{
    toasts: IToast[];
    addToast: (toast: IToast) => void;
    removeToast: (id: number) => void;
}>({
    toasts: [],
    addToast: () => {},
    removeToast: () => {}
});

const ToastContextProvider: React.FunctionComponent = ({ children }) => {
    let toastId = 0;

    const [toasts, setToasts] = useState<IToast[]>([]);

    const addToast = (toast: IToast) => {
        const newToast: IToast = {
            title: toast.title,
            type: toast.type,
            message: toast.message,
            duration: toast.duration,
            toastId: toastId
        };

        setToasts((toasts) => [...toasts, newToast]);
        toastId++;
    };

    const removeToast = (id: number) => {
        setToasts((toasts) => toasts.filter((toast: IToast) => toast.toastId !== id));
    };

    return <ToastContext.Provider value={{ toasts, addToast, removeToast }}>{children}</ToastContext.Provider>;
};

export default ToastContextProvider;
